import { useCreateAptStore } from "@elixir/stores";
import { BasicDoctorInfo } from "@elixir/types";
import React, { useMemo } from "react";
import { NewAptSelectClinicUi } from "ui";
import useQueueStore from "../../../../stores/queue-store";
import { useMyAccessProfileV2 } from "../../../../apis/tryst/get-my-access-profile";
import SearchClinicDropdown from "./search-clinic";
import useGetQueueConfig from "../../../../apis/tryst/get-queue-config";

const NewAptSelectClinic = () => {
  const { data: queueConfigData, isLoading } = useGetQueueConfig();

  const queueClinicId = useQueueStore((state) => state.clinicId);
  const clearSelectedSlot = useQueueStore((state) => state.clearSelectedSlot);

  const { data: myAccessProfile } = useMyAccessProfileV2({ clinicId: queueClinicId });

  const dropdownSelectedClinic = useCreateAptStore(
    (state) => state.selectedClinic
  );

  const setDropdownSelectedClinic = useCreateAptStore(
    (state) => state.setSelectedClinic
  );

  const [searchTerm, setSearchTerm] = React.useState("");
  const eligibleForClinicApts =
    queueConfigData?.data?.apt_config?.allow_clinic_booking || false;

  const clinicsOptions = useMemo(() => {
    const clinicsList = [...(myAccessProfile?.clinics || [])].map((clinic) => ({
      clinics: [clinic.id],
      name: clinic?.name || "",
      oid: clinic.id,
      pic: "https://cdn.eka.care/vagus/cm3cwdw5000000tj725smdgjo.png",
      username: "/",
    }));
    return clinicsList;
  }, [
    queueClinicId,
    eligibleForClinicApts,
    myAccessProfile?.clinics,
    myAccessProfile?.doctors,
  ]);

  React.useEffect(() => {
    if (queueClinicId && queueClinicId !== "all") {
      setDropdownSelectedClinic(queueClinicId);
    } else if (!dropdownSelectedClinic) {
      setDropdownSelectedClinic(clinicsOptions?.[0]?.oid);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [myAccessProfile?.doctors, queueClinicId]);

  React.useEffect(() => {
    if (queueClinicId && queueClinicId !== "all") {
      setDropdownSelectedClinic(queueClinicId);
    } 
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queueClinicId]);

  const onSelectClinicClick = (clinic?: BasicDoctorInfo) => {
    clearSelectedSlot();
    setDropdownSelectedClinic(clinic?.oid);
  };

  if (!(eligibleForClinicApts || myAccessProfile?.clinics?.length && myAccessProfile?.clinics?.length > 1)) {
    return null;
  }

  let selectedClinicInfo: BasicDoctorInfo | undefined = undefined;

  if (dropdownSelectedClinic) {
    selectedClinicInfo = clinicsOptions.find(
      (clinic) => clinic.oid === dropdownSelectedClinic
    );
  }

  return (
    <NewAptSelectClinicUi
      selectedClinic={selectedClinicInfo}
      onClear={() => {
        onSelectClinicClick(undefined);
      }}
      fieldTitle={"Clinic"}
      fieldPlaceholder={
        "Select Clinic"
      }
      onSearchTermChange={setSearchTerm}
      suggestionsUi={
        <SearchClinicDropdown
          clinicsData={clinicsOptions}
          searchQuery={searchTerm}
          onSelectClinic={onSelectClinicClick}
        />
      }
      searchTerm={searchTerm}
    />
  );
};

export default NewAptSelectClinic;
